//dependencies
import { z } from "zod";

export const REVIEWS_TABLE_LIMIT = 25;

export const USER_REVIEWS_MODALS = ["createReview", "add360Form"] as const;

export const USER_REVIEWS_CONFIG = {
	queryParametersSchema: z.object({
		modal: z.enum(USER_REVIEWS_MODALS).optional().nullable().catch(null),
	}),
};
